import { render, staticRenderFns } from "./liensAndJudgments.vue?vue&type=template&id=283c1069"
import script from "./liensAndJudgments.vue?vue&type=script&lang=js"
export * from "./liensAndJudgments.vue?vue&type=script&lang=js"
import style0 from "./liensAndJudgments.vue?vue&type=style&index=0&id=283c1069&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports